import React from "react";
import WidgetChangelogIcon from "../widget-changelog-icon/WidgetChangelogIcon";
import { WidgetMarginHeight } from "../../../styles/SharedStyles";

const WidgetChangelogFrame = ({ showUpdatesList, handleShowUpdatesListClick, updatesListGeneralUi }) => {
  return (
    <>
      <WidgetChangelogIcon showUpdatesList={showUpdatesList} handleShowUpdatesListClick={handleShowUpdatesListClick} />
      <WidgetMarginHeight height="0.6rem" />
      {showUpdatesList ? updatesListGeneralUi() : <div />}
    </>
  );
};

export default WidgetChangelogFrame;
